/* eslint-disable */
import jQuery from "jquery";

jQuery(function ($) {

    if (window.ScrollMagic) {

        // init controller
        var controller = new ScrollMagic.Controller();
        var isScrollMagic = false;
        var tween = null;
        var scene = null;

        var setScrollMagic = function () {

            // Image Sequence Panels
            $('.fw-panel--sequence').each(function () {

                var container = $(this);
                var containerHeight = container.outerHeight();
                var $backgroundImages = container.find('.js-image');

                if (window.innerWidth > 1023) {
                    isScrollMagic = true;
                    container.css({ 'height': containerHeight });
                    var sectionTL = new TimelineMax();

                    $backgroundImages.each(function (i, item) {
                        tween = sectionTL.add(TweenMax.to(item, i + 1, { zIndex: i + 1, y: "0", ease: Linear.easeNone }));
                    });

                    scene = new ScrollMagic.Scene({ triggerElement: container[0], duration: 1500, offset: containerHeight / 2 })
                        .setTween(tween)
                        .setPin(container[0])
                        .addTo(controller);
                }
            });
        };

        var checkIsScrollMagic = function () {
            if (window.innerWidth <= 1023 && isScrollMagic) {

                $('.fw-panel--sequence').each(function () {
                    var container = $(this);
                    var $backgroundImages = container.find('.js-image');

                    controller.destroy(container[0]);
                    container.css({ 'height': '' });

                    $backgroundImages.each(function (i, item) {
                        $backgroundImages.removeAttr('style');
                    });
                });
                controller = null;
                tween = null;
                scene = null;
                isScrollMagic = false;

            } else {
                if (!isScrollMagic) {
                    controller = new ScrollMagic.Controller();
                    setScrollMagic();
                }
            }
        };

        var setBackgroundHeightLimit = function () {
            $('.fw-panel--full-height').each(function () {
                $(this).find('.fw-panel__background').removeClass('fw-panel__background--limit');
                if ($(this).outerHeight() > window.innerHeight && !$(this).hasClass('fw-panel--fixed-bg')) { // && window.innerWidth < 1280
                    $(this).find('.fw-panel__background').addClass('fw-panel__background--limit');
                }
            });
        };

        setScrollMagic();
        setBackgroundHeightLimit();

        $(window).resize(function () {
            checkIsScrollMagic();
            setBackgroundHeightLimit();
        });

    }

    // -------------
    //  Lazy load the background images of the Panels
    // -------------
    function isInViewport(el) {
        //var offset = 500;
        var elementTop = el.offset().top;
        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();
        return elementTop < viewportBottom + lazyLoadOffset;
    }

    function lazyLoad(el) {
        el.find('picture').each(function () {
            var pictureSource = $(this).find('source');
            var srcset = pictureSource.data('srcset');
            var img = $(this).find('img');
            var src = img.data('src');

            pictureSource.attr('srcset', srcset);
            img.attr('src', src);
        });
        el.removeClass('js-background-image');
    }

    $('.js-background-image').each(function () {
        if (isInViewport($(this))) {
            lazyLoad($(this));
        }
    });

    // TODO: Maybe throttle this?
    $(window).on('resize scroll', function () {
        $('.js-background-image').each(function () {
            if (isInViewport($(this))) {
                lazyLoad($(this));
            }
        });
    });
}); //jQuery